import { render, staticRenderFns } from "./FullscreenModal.vue?vue&type=template&id=bc3319ce&scoped=true"
import script from "./FullscreenModal.vue?vue&type=script&lang=js"
export * from "./FullscreenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3319ce",
  null
  
)

export default component.exports